import { ExperiencePageTargetingFe } from "@intelligems/ig-types/fe-only/page-targeting";

export interface IPageTargetingState {
  isSuccess: boolean;
  pageTargeting: ExperiencePageTargetingFe[];
  storedPageTargeting: ExperiencePageTargetingFe[];
}

export const initialIPageTargetingState: IPageTargetingState = {
  isSuccess: false,
  pageTargeting: [],
  storedPageTargeting: [],
};
